import { useEffect } from "react";

/**
 * Custom hook to set the document title for each page
 * Format: "Page Title | Cyberagrópolis - Tang Gold"
 * 
 * @param title - The specific page title
 */
export const usePageTitle = (title: string) => {
  useEffect(() => {
    const baseTitle = "Cyberagrópolis - Tang Gold";
    document.title = title ? `${title} | ${baseTitle}` : baseTitle;
    
    return () => {
      document.title = baseTitle;
    };
  }, [title]);
};
